var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 19,
    viewBox: "0 0 36 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.974 1.61768C35.974 2.16996 35.5263 2.61768 34.974 2.61768H1.1748C0.62252 2.61768 0.174805 2.16996 0.174805 1.61768C0.174805 1.06539 0.62252 0.617676 1.1748 0.617676H34.974C35.5263 0.617676 35.974 1.06539 35.974 1.61768ZM35.974 9.61768C35.974 10.17 35.5263 10.6177 34.974 10.6177H1.1748C0.62252 10.6177 0.174805 10.17 0.174805 9.61768C0.174805 9.06539 0.62252 8.61768 1.1748 8.61768H34.974C35.5263 8.61768 35.974 9.06539 35.974 9.61768ZM34.974 18.6177C35.5263 18.6177 35.974 18.17 35.974 17.6177C35.974 17.0654 35.5263 16.6177 34.974 16.6177H1.1748C0.62252 16.6177 0.174805 17.0654 0.174805 17.6177C0.174805 18.17 0.62252 18.6177 1.1748 18.6177H34.974Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.f8e5f42d7e9d791935a33a2b2d146df3.svg";
export { ForwardRef as ReactComponent };